<div class="ag-checkbox">
  <eds-checkbox
    [id]="uniqueInputId"
    [hideLabel]="true"
    [stopEventTracking]="true"
    [checked]="isSelected"
    (checkedChange)="onSelectAllClick($event)"
    [required]="false"
    [tabIndex]="0"
    [hasFocusShadow]="false"
    [name]="params?.data?.literatureData?.fundNameGenerated"
  ></eds-checkbox>
  <label [for]="uniqueInputId" class="sr-only">{{
    params?.data?.literatureData?.fundNameGenerated
  }}</label>
</div>
